/*
Discipline bento: enter stagger.
Why: sequences the tiles so the eye reads them in order instead of hitting
all six at once.
*/

export function disciplines(gsap) {
  const tiles = document.querySelectorAll('.bento .tile');

  if (!tiles.length) return;

  gsap.fromTo(tiles, { y: 30, opacity: 0 }, {
    y: 0,
    opacity: 1,
    duration: 0.7,
    ease: 'power3.out',
    stagger: 0.07,
    clearProps: 'transform',
    scrollTrigger: { trigger: '.bento', start: 'top 82%', once: true },
  });
}
